<h2>Participating Aggregator Search</h2>
<div class="search__container">
  <div class="search__description">
    <p>
      This is a list of all SMS Providers registered with ComReg.
    </p>
    <p>
      Only registered SMS Providers can handle registered Sender IDs in Ireland.
    </p>
  </div>
  <div class="search__form-group">
    <form [formGroup]="form" class="search__form">
      <mat-form-field class="search__input">
        <mat-label>Search</mat-label>
        <input matInput formControlName="search" id="search" type="text" />
        <mat-error comFormMessageName="search">Please enter valid name aggregator or provider name</mat-error>
      </mat-form-field>
    </form>
    <button mat-raised-button class="button--secondary" [routerLink]="'/'">Back</button>
  </div>

  <table mat-table matSort [dataSource]="paDataSource">
    <ng-container matColumnDef="erauReference">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        ERAU Reference
        <mat-icon class="search__icon" matTooltip="ERAU - Electronic Register of Authorised Undertakings reference number as registered on the ComReg Service Registry.">
          info
        </mat-icon>
      </th>
      <td mat-cell *matCellDef="let element" [siExactMatch]="isExactMatch(element)">
        {{ element.erauReference }}
      </td>
    </ng-container>

    <ng-container matColumnDef="organisationName">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Organisation Name</th>
      <td mat-cell *matCellDef="let element" [siExactMatch]="isExactMatch(element)">
        {{ element.organisationName }}
      </td>
    </ng-container>

    <tr *matNoDataRow>
      <td colspan="2">Providers list is empty</td>
    </tr>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="TableConstants.pageSize" aria-label="Page size"></mat-paginator>
</div>
